// src/pages/UserPage/sections/OrganizationDeliveries/dashboard/constants.js

export const BILLING_STATUS = {
  pending:  { label: 'Odottaa',    color: 'warning' },
  invoiced: { label: 'Laskutettu', color: 'info'    },
  paid:     { label: 'Maksettu',   color: 'success' },
};

export const getBillingStatus = (delivery) =>
  delivery.invoiceStatus || 'pending';

export const fmtDateOnly = (ms) => {
  if (!ms) return '—';
  return new Date(ms).toLocaleDateString('fi-FI', {
    day: 'numeric', month: 'short', year: 'numeric',
    timeZone: 'Europe/Helsinki',
  });
};
